// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"487":"1fc6b241","612":"81f2f3a0","722":"6e9befc5","1007":"81f2f3a0","1470":"6e9befc5","1545":"81f2f3a0","4572":"6e9befc5","5478":"81f2f3a0","6152":"6e9befc5"}[chunkId] + ".chunk.css";
};